
export default function CaseStudyHero() {
  return (
    <section className="pt-24 pb-0">
      {/* Hero Banner with Gradient */}
      <div className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #182423 0%, #2a3d3b 50%, #182423 100%)' }}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 rounded-full" style={{ background: '#F16051', filter: 'blur(100px)' }}></div>
          <div className="absolute bottom-20 right-20 w-80 h-80 rounded-full" style={{ background: '#F16051', filter: 'blur(80px)' }}></div>
        </div>
        
        <div className="max-w-6xl mx-auto px-6 py-20 relative z-10">
          <div className="flex items-center gap-3 mb-6">
            <span className="px-4 py-2 rounded-full text-sm font-semibold" style={{ backgroundColor: '#F16051', color: 'white' }}>
              Enterprise SaaS
            </span>
            <span className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium text-white">
              B2B Platform
            </span>
          </div>
          
          <h1 className="text-6xl md:text-7xl font-black text-white mb-6 tracking-tight">
            SureWorx
          </h1>
          
          <p className="text-xl md:text-2xl text-white/80 max-w-3xl leading-relaxed mb-12">
            Unified construction management platform for Australian enterprise teams — consolidating 7 critical systems into one powerful solution.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: 'Industry', value: 'Construction', icon: 'ri-building-2-line' },
              { label: 'Role', value: 'Senior UX Designer', icon: 'ri-user-star-line' },
              { label: 'Duration', value: '18 months', icon: 'ri-calendar-line' },
              { label: 'Platform', value: 'Web Application', icon: 'ri-computer-line' }
            ].map((item, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/10">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-3" style={{ backgroundColor: '#F16051' }}>
                  <i className={`${item.icon} text-white text-lg`}></i>
                </div>
                <p className="text-white/60 text-xs uppercase tracking-wider mb-1">{item.label}</p>
                <p className="text-white font-semibold">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <h2 className="text-3xl font-bold mb-6" style={{ color: '#182423' }}>Project Overview</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              SureWorx is an enterprise B2B SaaS platform designed for large-scale construction organizations operating across Australia. The platform consolidates seven critical business systems into a single, unified interface—eliminating the complexity of managing multiple disconnected tools.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              This case study explores the UX challenges of designing for compliance-heavy workflows, role-based access across organizational hierarchies, and the scalability requirements of enterprise construction management.
            </p>
          </div>
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 border border-gray-200">
            <h3 className="font-bold text-gray-900 mb-4">Key Deliverables</h3>
            <ul className="space-y-3">
              {['UX Research & Strategy', 'Information Architecture', 'Design System', 'UI Design', 'Prototyping'].map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs" style={{ backgroundColor: '#F16051' }}>
                    <i className="ri-check-line"></i>
                  </span>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
